import { useCallback, useEffect, useState } from 'react';
import client from '../api/client';

export function useSurvey(token, surveyId) {
  const [participant, setParticipant] = useState(null);
  const [survey, setSurvey] = useState(null);
  const [responseId, setResponseId] = useState(null);
  const [currentQuestion, setCurrentQuestion] = useState(null);
  const [progress, setProgress] = useState(0);
  const [isComplete, setIsComplete] = useState(false);

  useEffect(() => {
    if (!token) return;

    client
      .get('/chatbot/init', {
        params: {
          token,
          survey_id: surveyId ? Number(surveyId) : undefined,
        },
      })
      .then((res) => {
        const data = res.data?.data || {};
        setParticipant(data.participant || null);
        setSurvey(data.survey || null);
        setResponseId(data.response?.id || null);
        setCurrentQuestion(data.current_question || null);
        setProgress(data.progress || 0);
      })
      .catch(() => {
        setCurrentQuestion(null);
      });
  }, [token, surveyId]);

  const applyAnswerResult = useCallback((data) => {
    setCurrentQuestion(data.current_question || null);
    setProgress(data.progress || 0);
    if (data.is_complete) {
      setIsComplete(true);
    }
  }, []);

  const submitAnswer = useCallback(
    async (payload) => {
      if (!token || !payload?.question_id) return null;

      const res = await client.post('/chatbot/answer', {
        token,
        survey_id: surveyId ? Number(surveyId) : undefined,
        ...payload,
      });

      const data = res.data?.data || {};
      applyAnswerResult(data);
      return data;
    },
    [token, surveyId, applyAnswerResult]
  );

  const goPrevious = useCallback(async (currentQid) => {
    if (!token) return null;
    try {
      const res = await client.get('/chatbot/previous', {
        params: {
          token,
          survey_id: surveyId ? Number(surveyId) : undefined,
          current_question_id: currentQid || undefined,
        },
      });
      const data = res.data?.data || {};
      if (data.question) {
        setCurrentQuestion(data.question);
        if (typeof data.progress === 'number') setProgress(data.progress);
        return data.question;
      }
      return null;
    } catch {
      return null;
    }
  }, [token, surveyId]);

  return {
    participant,
    survey,
    responseId,
    currentQuestion,
    progress,
    isComplete,
    submitAnswer,
    applyAnswerResult,
    goPrevious,
  };
}
